// Chip de una promo que solo aplica con ciertas formas de pago («Solo SureKeep o efectivo»).
export function PaymentOptionsChip({ label }: { label: string }) {
    return (
        <span className="inline-flex flex-none whitespace-nowrap rounded-full bg-promo-soft px-1.5 py-px text-[10.5px] font-bold text-promo">
            {label}
        </span>
    );
}
